export const testData0 = `
Привет это сервис по озвучиванию книжек.
`

export const testData1 = `
Привет Мир!
[{(Привет Мир два!)}]
'"Привет Мир три!"'
Привет Мир четыре.
Hello World 6

0123456789

Во все большем количестве российских изданий − как печатных, так и онлайновых − появляются объемные материалы особого типа, за которыми в журналистской среде закрепилось название «длинные тексты» (англ. – long forms) или лонгриды (от англ. − long read – материал, предназначенный для длительного прочтения, в отличие от маленькой заметки). Сразу же следует оговориться, что объем материала – хотя и наиболее заметная, но не ключевая характеристика лонгрида. Объемными могут быть и материалы других жанров, поэтому сам по себе большой объем текста вовсе не означает, что перед нами лонгрид. Как будет показано в исследовании, лонгриды отличает также особый подход к выбору темы, требования к качеству собранной информации и способ подачи материала. В исследовании предпринята попытка описать типологические характеристики лонгридов, разобрать особенности их подготовки, а также выявить распространенность лонгридов в современной российской прессе. Еще одной целью исследования является оценка перспектив этого жанра, о котором можно говорить если не как о сложившемся (в принятых на сегодняшний день в научной среде жанровых классификациях лонгрид отсутствует), то как о складывающемся и проникающем во все большее количество изданий.
`

export const testData2 = `
«Три поросенка»

Жили-были на свете три поросёнка. Три брата.

Все одинакового роста, кругленькие, розовые, с одинаковыми весёлыми хвостиками.

Три поросенка
Даже имена у них были похожи. Звали поросят Ниф-Ниф, Нуф-Нуф и Наф-Наф. Всё лето они кувыркались в зелёной траве, грелись на солнышке, нежились в лужах.

Но вот наступила осень.

Солнце уже не так сильно припекало, серые облака тянулись над пожелтевшим лесом.

— Пора нам подумать о зиме, — сказал как-то Наф-Наф своим братьям, проснувшись рано утром. — Я весь дрожу от холода. Мы можем простудиться. Давайте по строим дом и будем зимовать вместе под одной тёплой крышей.

Но его братьям не хотелось браться за работу. Гораздо приятнее в последние тёплые дни гулять и прыгать по лугу, чем рыть землю и таскать тяжёлые камни.

Три поросенка
— Успеется! До зимы ещё далеко. Мы ещё погуляем,— сказал Ниф-Ниф и пере кувырнулся через голову.

— Когда нужно будет, я сам построю себе дом,— сказал Нуф-Нуф и лёг в лужу.

— Я тоже,— добавил Ниф-Ниф.

— Ну, как хотите. Тогда я буду один строить себе дом,— сказал Наф-Наф.— Я не буду вас дожидаться.

С каждым днём становилось всё холод нее и холоднее.

Но Ниф-Ниф и Нуф-Нуф не торопились. Им и думать не хотелось о работе. Они бездельничали с утра до вечера. Они только и делали, что играли в свои поросячьи игры, прыгали и кувыркались.

— Сегодня мы ещё погуляем,— говорили они,— а завтра с утра возьмёмся за дело.

Но и на следующий день они говорили то же самое.

И только тогда, когда большая лужа у дороги стала по утрам покрываться тоненькой корочкой льда, ленивые братья взялись наконец за работу.

Ниф-Ниф решил, что проще и скорее всего смастерить дом из соломы. Ни с кем не посоветовавшись, он так и сделал. Уже к вечеру его хижина была готова.

Три поросенка
Ниф-Ниф положил на крышу последнюю соломинку и, очень довольный своим домиком, весело запел:

Хоть полсвета обойдёшь,

Обойдёшь, обойдёшь,

Лучше дома не найдёшь,

Не найдёшь, не найдёшь!

Напевая эту песенку, он направился к Нуф-Нуфу.

Нуф-Нуф невдалеке тоже строил себе домик. Он старался скорее покончить с этим скучным и неинтересным делом. Сначала, так же как и брат, он хотел по строить себе дом из соломы. Но потом ре шил, что в таком доме зимой будет очень холодно. Дом будет прочнее и теплее, если его построить из веток и тонких прутьев.

Так он и сделал.

Он вбил в землю колья, переплёл их прутьями, на крышу навалил сухих листьев, и к вечеру дом был готов.

Три поросенка
Нуф-Нуф с гордостью обошёл его несколько раз кругом и запел:

У меня хороший дом,

Новый дом, прочный дом.

Мне не страшен дождь и гром,

Дождь и гром, дождь и гром!

Не успел он закончить песенку, как из- за куста выбежал Ниф-Ниф.

Три поросенка
— Ну вот и твой дом готов! — сказал Ниф-Ниф брату.— Я говорил, что мы и одни справимся с этим делом! Теперь мы свободны и можем делать всё, что нам вздумается!

— Пойдём к Наф-Нафу и посмотрим, какой он себе выстроил дом! — сказал Нуф-Нуф.— Что-то мы его давно не видели!

— Пойдём посмотрим! — согласился Ниф-Ниф.

И оба брата, довольные тем, что им ни о чём больше не нужно заботиться, скрылись за кустами.

Наф-Наф вот уже несколько дней был занят постройкой. Он натаскал камней, на месил глины и теперь не спеша строил себе надёжный, прочный дом, в котором можно было бы укрыться от ветра, дождя и мороза.

Три поросенка
Он сделал в доме тяжёлую дубовую дверь с засовом, чтобы волк из соседнего леса не мог к нему забраться.

Ниф-Ниф и Нуф-Нуф застали брата за работой.

— Что ты строишь?! — в один голос закричали удивлённые Ниф-Ниф и Нуф- Нуф. — Что это, дом для поросёнка или крепость?

— Дом поросёнка должен быть крепостью! — спокойно ответил им Наф-Наф, продолжая работать.

— Не собираешься ли ты с кем-нибудь воевать? — весело прохрюкал Ниф-Ниф и подмигнул Нуф-Нуфу.

И оба брата так развеселились, что их визг и хрюканье разнеслись далеко по лужайке.

Три поросенка
А Наф-Наф как ни в чём не бывало продолжал класть каменную стену своего дома, мурлыча себе под нос песенку:

Я, конечно, всех умней,

Всех умней, всех умней!

Дом я строю из камней,

Из камней, из камней!

Никакой на свете зверь,

Хитрый зверь, страшный зверь,

Не ворвётся в эту дверь,

В эту дверь, в эту дверь!

— Это он про какого зверя? — спросил Ниф-Ниф у Нуф-Нуфа.

— Это ты про какого зверя? — спросил Нуф-Нуф у Наф-Нафа.

— Это я про волка! — ответил Наф-Наф и уложил ещё один камень.

— Посмотрите, как он боится волка! — сказал Ниф-Ниф.

— Он боится, что его съедят! — до бавил Нуф-Нуф.

И братья ещё больше развеселились.

— Какие здесь могут быть волки? — сказал Ниф-Ниф.

— Никаких волков нет! Он просто трус! — добавил Нуф-Нуф.

И оба они начали приплясывать и петь:

Нам не страшен серый волк,

Серый волк, серый волк!

Где ты ходишь, глупый волк,

Старый волк, страшный волк?

Они хотели подразнить Наф-Нафа, но тот даже не обернулся.

— Пойдём, Нуф-Нуф,— сказал тогда Ниф-Ниф.— Нам тут нечего делать!

И два храбрых братца пошли гулять.

По дороге они пели и плясали, а когда вошли в лес, то так расшумелись, что разбудили волка, который спал под сосной.

Три поросенка
— Что за шум? — недовольно про ворчал злой и голодный волк и поскакал к тому месту, откуда доносились визг и хрюканье двух маленьких глупых поросят.

— Ну какие тут могут быть волки! — говорил в это время Ниф-Ниф, который волков видел только на картинках.

— Вот мы его схватим за нос, будет знать! — добавил Нуф-Нуф, который тоже никогда не видел живого волка.

— Повалим, да ещё свяжем, да ещё ногой вот так, вот так! —- расхвастался Ниф-Ниф и показал, как они будут расправляться с волком.

И братья опять развеселились и запели:

Нам не страшен серый волк,

Серый волк, серый волк!

Где ты ходишь, глупый волк,

Старый волк, страшный волк?

Три поросенка
И вдруг они увидели настоящего живого волка! Он стоял за большим деревом, и у него был такой страшный вид, такие злые глаза и такая зубастая пасть, что у Ниф-Нифа и Нуф-Нуфа по спинкам про бежал холодок и тонкие хвостики мелко мелко задрожали.

Бедные поросята не могли даже пошевельнуться от страха.

Волк приготовился к прыжку, щёлкнул зубами, моргнул правым глазом, но поросята вдруг опомнились и, визжа на весь лес, бросились наутёк.

Три поросенка
Никогда ещё не приходилось им так быстро бегать! Сверкая пятками и поднимая тучи пыли, поросята неслись каждый к своему дому.

Ниф-Ниф первый добежал до своей соломенной хижины и едва успел захлопнуть дверь перед самым носом волка.

Три поросенка
— Сейчас же отопри дверь! — прорычал волк.— А не то я её выломаю!

— Нет,— прохрюкал Ниф-Ниф,— я не отопру!

За дверью было слышно дыхание страшного зверя.

— Сейчас же отопри дверь! — прорычал опять волк.— А не то я так дуну, что весь твой дом разлетится!

Но Ниф-Ниф от страха ничего уже не мог ответить.

Тогда волк начал дуть: «Ф-ф-ф-у-у-у!»

С крыши дома слетали соломинки, стены дома тряслись.

Волк ещё раз глубоко вдохнул и дунул во второй раз: «Ф-ф-ф-у-у-у!»

Когда волк дунул в третий раз, дом разлетелся во все стороны, как будто на него налетел ураган.

Три поросенка
Волк щёлкнул зубами перед самым пятачком маленького поросёнка. Но Ниф-Ниф ловко увернулся и бросился бежать. Через минуту он был уже у двери Нуф-Нуфа.

Едва успели братья запереться, как услышали голос волка:

— Ну, теперь я съем вас обоих!

Три поросенка
Ниф-Ниф и Нуф-Нуф испуганно поглядели друг на друга. Но волк очень устал и потому решил пойти на хитрость.

— Я передумал! — сказал он так громко, чтобы его услышали в домике.— Я не буду есть этих худосочных поросят! Я лучше пойду домой!

— Ты слышал? — спросил Ниф-Ниф у Нуф-Нуфа.— Он сказал, что не будет нас есть! Мы — худосочные!

— Это очень хорошо! — сказал Нуф- Нуф и сразу перестал дрожать.

Братьям стало весело, и они запели как ни в чём не бывало:

Нам не страшен серый волк,

Серый волк, серый волк!

Где ты ходишь, глупый волк,

Старый волк, страшный волк?

Три поросенка
А волк и не думал никуда уходить. Он просто отошёл в сторонку и притаился. Ему было очень смешно. Он с трудом сдерживал себя, чтобы не расхохотаться. Как ловко он обманул двух глупых, маленьких поросят!

Когда поросята совсем успокоились, волк взял овечью шкуру и осторожно под крался к дому.

У дверей он накрылся шкурой и тихо постучал.

Ниф-Ниф и Нуф-Нуф очень испугались, когда услышали стук.

— Кто там? — спросили они, и у них снова затряслись хвостики.

— Это я-я-я, бедная маленькая овечка! — тонким, чужим голосом пропищал волк.— Пустите меня переночевать, я от билась от стада и очень устала!

— Пустить? — спросил брата добрый Ниф-Ниф.

— Овечку можно пустить! — согласился Нуф-Нуф.— Овечка — не волк!

Но когда поросята приоткрыли дверь, они увидели не овечку, а всё того же зубастого волка. Братья захлопнули дверь и изо всех сил налегли на неё, чтобы страшный зверь не смог к ним ворваться.

Волк очень рассердился. Ему не уда лось перехитрить поросят. Он сбросил с себя овечью шкуру и зарычал:

— Ну, погодите же! От этого дома сей час ничего не останется!

И он принялся дуть. Дом немного по косился. Волк дунул второй, потом третий, потом четвёртый раз.

С крыши слетали листья, стены дрожа ли, но дом всё ещё стоял.

И только когда волк дунул в пятый раз, дом зашатался и развалился. Одна только дверь некоторое время ещё стояла посреди развалин.

Три поросенка
В ужасе бросились поросята бежать. От страха у них отнимались ноги, каждая щетинка дрожала, носы пересохли. Братья мчались к дому Наф-Нафа.

Волк нагонял их огромными скачками. Один раз он чуть не схватил Ниф-Нифа за заднюю ножку, но тот вовремя отдёрнул её и прибавил ходу.

Волк тоже поднажал. Он был уверен, что на этот раз поросята от него не убегут.

Но ему опять не повезло.

Поросята быстро промчались мимо большой яблони, даже не задев её. А волк не успел свернуть и налетел на яблоню, которая осыпала его яблоками. Одно твёрдое яблоко ударило ему между глаз. Большая шишка вскочила у волка на лбу.

Три поросенка
А Ниф-Ниф и Нуф-Нуф ни живы ни мёртвы подбежали в это время к дому Наф-Нафа.

Брат впустил их в дом. Бедные порося та были так напуганы, что ничего не могли сказать. Они молча бросились под кровать и там притаились.

Три поросенка
Наф-Наф сразу догадался, что за ними гнался волк. Но ему нечего было бояться в своём каменном доме. Он быстро за крыл дверь на засов, сел на табуреточку и громко запел:

Никакой на свете зверь,

Хитрый зверь, страшный зверь,

Не откроет эту дверь,

Эту дверь, эту дверь!

Три поросенка
Но тут как раз постучали в дверь.

— Кто стучит? — спокойным голосом спросил Наф-Наф.

— Открывай без разговоров! — раздался грубый голос волка.

— Как бы не так! И не подумаю! — твёрдым голосом ответил Наф-Наф.

— Ах, так! Ну, держитесь! Теперь я съем всех троих!

— Попробуй! — ответил из-за двери Наф-Наф, даже не привстав со своей табуреточки.

Он знал, что ему и братьям нечего бояться в прочном каменном доме.

Три поросенка
Тогда волк втянул в себя побольше воздуха и дунул как только мог! Но сколь ко бы он ни дул, ни один даже самый маленький камень не сдвинулся с места.

Волк посинел от натуги.

Дом стоял как крепость. Тогда волк стал трясти дверь. Но дверь тоже не поддавалась.

Волк стал от злости царапать когтями стены дома и грызть камни, из которых они были сложены, но он только обломал себе когти и испортил зубы. Голодному и злому волку ничего не оставалось делать, как убираться восвояси.

Но тут он поднял голову и вдруг за метил большую, широкую трубу на крыше.

— Ага! Вот через эту трубу я и про берусь в дом! — обрадовался волк.

Он осторожно влез на крышу и прислушался. В доме было тихо.

Три поросенка
«Я всё-таки закушу сегодня свежей поросятинкой»,— подумал волк и, облизнувшись, полез в трубу.

Но как только он стал спускаться по трубе, поросята услышали шорох. А когда на крышку котла стала сыпаться сажа, умный Наф-Наф сразу догадался, в чём дело.

Он быстро бросился к котлу, в котором на огне кипела вода, и сорвал с него крышку.

— Милости просим! — сказал Наф-Наф и подмигнул своим братьям.

Ниф-Ниф и Нуф-Нуф уже совсем успокоились и, счастливо улыбаясь, смотрели на своего умного и храброго брата.

Поросятам не пришлось долго ждать. Чёрный, как трубочист, волк бултыхнулся прямо в кипяток.

Три поросенка
Никогда ещё ему не было так больно!

Глаза у него вылезли на лоб, вся шерсть поднялась дыбом.

С диким рёвом ошпаренный волк вы летел в трубу обратно на крышу, скатился по ней на землю, перекувырнулся четыре раза через голову, проехался на своём хвосте мимо запертой двери и бросился в лес.

Три поросенка
А три брата, три маленьких поросёнка, глядели ему вслед и радовались, что они так ловко проучили злого разбойника.

А потом они запели свою весёлую песенку:

Хоть полсвета обойдёшь,

Обойдёшь, обойдёшь,

Лучше дома не найдёшь,

Не найдёшь, не найдёшь!

Никакой на свете зверь,

Хитрый зверь, страшный зверь,

Не откроет эту дверь,

Эту дверь, эту дверь!

Волк из леса никогда,

Никогда, никогда

Не вернётся к нам сюда,

К нам сюда, к нам сюда!

С этих пор братья стали жить вместе, под одной крышей.

Вот и всё, что мы знаем про трёх маленьких поросят — Ниф-Нифа, Нуф-Нуфа и Наф-Нафа.
`;
